import * as THREE from 'three'
import IntersectableObject from './IntersectableObject'

    class Icon extends IntersectableObject {
        constructor(controls, options) {
            super()
            this.options = options
            this.controls = controls
            const { src, width, height, segments, position, name, hidden, onClick, onClickEnd, color } = this.options

            this.color = color
            this.onClick = onClick || this.onClick

            this.selectEnd = this.selectEnd.bind(this)
            this.selectStart = this.selectStart.bind(this)
            this.handleImageLoad = this.handleImageLoad.bind(this)
            this.handleImageError = this.handleImageError.bind(this)

            // this.position.set(position.x, position.y, position.z)
            this.controls.addEventListener('selectStart', this.selectStart)
            this.controls.addEventListener('selectEnd', this.selectEnd)

            this.setImage(src)
        }

        tick (){
            if (!this.parent) {
                console.log('no parent')
            }
        }

        destroy (){
            this.controls.removeEventListener('selectStart', this.selectStart)
            this.controls.removeEventListener('selectEnd', this.selectEnd)
        }

        setImage(src){
            this.clear()
            const iconLoader = new THREE.ImageLoader()
            iconLoader.load(
                src,
                this.handleImageLoad,
                this.handleImageProgress,
                this.handleImageError
            )
        }
        
        selectEnd(event){
            this.clicking = false
        }

        selectStart(event){
            if (this.clicking) return
            this.clicking = true
            const evt = event.data
            const intersecting = this.checkForIntersects(evt)
            if (intersecting){
                 this.onClick()
            } 
        }


        onClick(){
            this.dispatchEvent({ type: 'click' })            
        }

        handleImageLoad(image) {
            const { width, height, segments, name, hidden, ignoreDepthTest, ignoreDepthWrite } = this.options
            const texture = new THREE.CanvasTexture(image)
            const material = new THREE.MeshStandardMaterial({
                alphaTest: 0.5,
                map: texture,
                transparent: true,
                side: THREE.DoubleSide,
                color: this.color || 'white'
            })
            const geometry = new THREE.PlaneBufferGeometry(width, height, segments)
            const mesh = new THREE.Mesh(geometry, material)
            mesh.customDepthMaterial = new THREE.MeshDepthMaterial({
                map: texture,
                depthPacking: THREE.RGBADepthPacking,
                alphaTest: 0.1
              })

            mesh.receiveShadow = true
            mesh.castShadow = true;
            mesh.renderOrder = 110
            this.add(mesh)
            this.controls.intersectableObjects = [mesh, ...this.controls.intersectableObjects]
            
            mesh.name = name
            mesh.visible = !hidden
            mesh.position.set(0, 0, 0)
        }

        handleImageProgress(progress) {
            //not supported
        }

        handleImageError(err) {
            console.log(err)
        }

        // checkForIntersects(evt) {
        //     const raycaster = evt.evt.data.raycaster
        //     const intersects = raycaster.intersectObjects([this], true)
        //     return intersects[0]
        // }

        setColor(color) {
            try {
                const mesh = this.children[0]
                if (!mesh) return
                const material = mesh.material
                material.color = new THREE.Color(color);
            } catch (e) {
                console.log(e)
            }
        }
    }

    export default Icon